// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nLIL","title":"styles_title__386CA"};